import React, { Component } from "react";
import HBNavbar from "./Components/Navbar/HBNavbar";

class Home extends Component {
  render() {
    return (
      <div className="dashboardbackgrnd">
        <HBNavbar className="HBNavigation" />
      </div>
    );
  }
}

export default Home;
